import * as React from "react";

export type SnackBarState = {
  message: string;
  open: boolean;
  mode: "default" | "info" | "warn" | "alert";
};

export type OpenAction = {
  message: string;
  mode?: "default" | "info" | "warn" | "alert";
};

export interface ISnackBarContext {
  card: SnackBarState;
  open: (payload: OpenAction) => void;
  close: () => void;
}

export const snackBarInitialState: SnackBarState = {
  open: false,
  message: "",
  mode: "default",
};

export default React.createContext<ISnackBarContext | null>(null);

export const initSnackBarStore: (initialState: SnackBarState) => ISnackBarContext = initialState => {
  const [card, setCard] = React.useState(initialState);

  return {
    card,
    open: payload => setCard(() => ({ ...card, open: true, ...payload })),
    close: () => setCard(() => ({ ...card, open: false, message: "" })),
  };
};
